import React, { FC } from 'react';
import SummaryImage from '../../summaryImage/SummaryImage';
import CurrencySwitchContainer from '../../currencySwitch/CurrencySwitchContainer';
import ChangeModel from '../../../changeModel/ChangeModel';
import useSalesEnablementContext from '../../../../../../../gqlCommon/hooks/useSalesEnablementContext';

interface ISummaryBaseContainerProps {
  imageUrl: string;
}

const SummaryBaseContainer: FC<ISummaryBaseContainerProps> = ({ imageUrl }) => {
  const { initializedWithStock } = useSalesEnablementContext();

  return (
    <>
      <SummaryImage imageUrl={imageUrl} />
      {!initializedWithStock && <ChangeModel variant="helpingText" align="center" />}
      <CurrencySwitchContainer />
    </>
  );
};

export default SummaryBaseContainer;
